
// constants as defined in RevoXef’s App\Models\Config\Discount
const ITEM  = 0;
const ORDER = 1;
const BOTH  = 2;

export default {
  ITEM,
  ORDER,
  BOTH,
}
